import React from 'react';
import ServiceList from '../../components/Service/ServiceList';

export const Service = () => {
  return (
    <ServiceList />
  );
}